<template>
    <div>
      <v-card class="pa-5">
        <div class="d-flex align-center mb-6">
          <h2 class="text-subtitle-1 font-weight-bold mr-4">
            {{ $t("fleet.title") }}
          </h2>
          <div>
            <SearchInput v-model="searchInputValue" />
          </div>
          <v-btn color="primary" dark class="ml-auto" @click="$router.push({ name: 'AddFleetVehicle' })">
            {{ $t("fleet.addNew") }}
          </v-btn>
        </div>
        <data-table
          ref="fleetTable"
          :headers="headers"
          endpoint="/Fleet/GetVehicles"
          serverPagination
          @click:row="onRowClick"
          :search="searchInputValue"
        >
        <template v-slot:[`item.size`]="{ item }">
          {{ getVehicleSize(item.size) }}
        </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="detailsFleetVehicle(item)">
                  <v-list-item-title>{{
                    $t("common.details")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="filter(item)">
                  <v-list-item-title>{{
                    $t("fleet.createFilter")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="searchReload(item)">
                  <v-list-item-title>{{
                    $t("fleet.searchReload")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="fleetCopyVehicle(item)">
                  <v-list-item-title>{{
                    $t("fleet.publish")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="addRoad(item)">
                  <v-list-item-title>{{
                    $t("fleet.roads.addRoad")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="editVehicle(item)">
                  <v-list-item-title>{{
                    $t("common.edit")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="deleteVehicle(item)">
                  <v-list-item-title>{{
                    $t("common.remove")
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getFleet">{{
              $t("users.slotNoData")
            }}</v-btn>
          </template>
        </data-table>
      </v-card>
      <Confirm ref="confirmDialog" />
      <FilterLoadPlaceDialog ref="filterLoadPlaceDialog" />
      <SearchReloadDialog ref="searchReloadDialog" />
    </div>
  </template>

<script>
import SearchInput from '@/components/search/SearchInput.vue'
import Service from '@/services'
import Confirm from '@/components/dialogs/Confirm.vue'
import FilterLoadPlaceDialog from './dialogs/FilterLoadPLaceDialog.vue'
import SearchReloadDialog from './dialogs/SearchReloadDialog.vue'

export default {
  name: 'Fleet',
  components: {
    Confirm,
    FilterLoadPlaceDialog,
    SearchReloadDialog,
    SearchInput
  },
  data () {
    return {
      total: 0,
      users: [],
      loading: true,
      options: {
        itemsPerPage: 10
      },
      searchInputValue: '',
      headers: [
        {
          text: this.$t('fleet.registrationNumber'),
          align: 'start',
          value: 'registrationNumber'
        },
        {
          text: this.$t('fleet.name'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$t('fleet.size'),
          value: 'size',
          align: 'start'
        },
        {
          text: this.$t('fleet.type'),
          value: 'typeName',
          align: 'start'
        },
        {
          text: '',
          align: 'end',
          width: '75',
          value: 'actions',
          sortable: false
        }
      ],
      loadingDialog: false
    }
  },
  watch: {
    options: {
      handler () {
        this.getFleet()
      },
      deep: true
    }
  },
  computed: {
    pageCount () {
      return Math.ceil(this.total / this.options.itemsPerPage)
    }
  },
  methods: {
    onRowClick (cellData, item) {
      this.detailsFleetVehicle(cellData)
    },
    async getFleet () {
      await this.$refs.fleetTable.getData()
    },
    getVehicleSize (size) {
      return this.$store.getters.enums.vehicleSizeTypes.find(type => type.id === size).description
    },
    editVehicle (item) {
      this.$router.push({ name: 'EditFleetVehicle', params: { id: item.id } })
    },
    fleetCopyVehicle (item) {
      this.$router.push({ name: 'FleetCopyVehicle', params: { id: item.id } })
    },
    detailsFleetVehicle (item) {
      this.$router.push({ name: 'DetailsFleetVehicle', params: { id: item.id } })
    },
    async filter (item) {
      this.$refs.filterLoadPlaceDialog.open(item)
    },
    async searchReload (item) {
      this.$refs.searchReloadDialog.open(item)
    },
    async addRoad (item) {
      this.loading = true
      try {
        const { data } = await Service.get('road/getroad', { vehicleId: item.id })
        if (data.count > 5) {
          await this.$store.dispatch('setErrorNotification', this.$t('fleet.roads.roadsLimit'))
          return
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
      this.$router.push({ name: 'AddRoad', params: { id: item.id } })
    },
    async deleteVehicle (item) {
      this.loadingDialog = true
      if (await this.$refs.confirmDialog.open(this.$t('deleteDialog.title'), `${this.$t('deleteDialog.label')} ${item.name}?`)) {
        try {
          await Service.delete('Fleet/Delete', { vehicleId: item.id })
          this.getFleet()
        } catch (e) {}
      }
      this.loadingDialog = false
    }
  }
}
</script>
  <style scoped>

  .stateChange {
    color: var(--v-stateChange);
  }
  .active {
    color: var(--v-primary);
  }
  </style>
